import request from "@/utils/request";
import download from "@/utils/download";
import omsRequest from "@/utils/oms-request";
import qs from "qs";

export const searchBookingOrderForSales = (params: any) =>
  request({
    url: "/booking-orders/finance",
    method: "GET",
    params
  });

export const searchBookingOrderForLogistics = (params: any) =>
  request({
    url: "/logistics-specialist/booking-orders",
    method: "GET",
    params
  });

export const searchBookingOrderForFinancial = (params: any) =>
  request({
    url: "/booking-orders",
    method: "GET",
    params
  });

export const createBookingOrder = (data: any) =>
  request({
    url: `/booking-orders`,
    method: "POST",
    data
  });

export const updateBookingOrder = (id: string, data: any) =>
  request({
    url: `/booking-orders/${id}`,
    method: "PUT",
    data
  });

export const updateDeadlineDate = (id: string, date: string) =>
  request({
    url: `/booking-orders/${id}/deadline-date`,
    method: "PUT",
    data: { deadlineDate: date }
  });

export const updateSailingSchedule = (id: string, date: string) =>
  request({
    url: `/booking-orders/${id}/sailing-schedule`,
    method: "PUT",
    data: { sailingSchedule: date }
  });
export const updateCheckPrerecordListDate = (id: string, date: string, sailingSchedule: string) =>
  request({
    url: `/booking-orders/${id}/check-prerecord-list-date`,
    method: "PUT",
    data: { checkPrerecordListDate: date, sailingSchedule: sailingSchedule }
  });

export const queryDeclarationInfo = (id: string) =>
  request({
    url: `/booking-orders/${id}/declaration-infos`,
    method: "GET"
  });

export const updateDeclarationInfo = (id: string, data: any) =>
  request({
    url: `/booking-orders/${id}/declaration-infos`,
    method: "PUT",
    data
  });
export const queryInvoice = (id: string) =>
  request({
    url: `/booking-orders/${id}/invoice`,
    method: "GET"
  });

/**
 * 查询报关单据
 * @param id
 * @param data
 */
export const getLoadingPlanLists = (id: string) =>
  request({
    url: `/loading-plan-lists`,
    method: "GET",
    params: { bookingOrderId: id }
  });

export const createLoadingPlanList = (data: any) =>
  request({
    url: `/loading-plan-lists`,
    method: "POST",
    data
  });

export const updateLoadingPlanList = (id: string, data: any) =>
  request({
    url: `/loading-plan-lists/${id}`,
    method: "PUT",
    data
  });

export const listProcessStages = () =>
  request({
    url: `/booking-orders/process-stages`,
    method: "GET"
  });
export const listProcessStagesFinance = () =>
  request({
    url: `/booking-orders/process-stages/finance`,
    method: "GET"
  });
export const invoiceProducts = (id: string) =>
  request({
    url: `/booking-orders/${id}/invoice-products`,
    method: "GET"
  });

export const downloadInvoiceTemplate = (id: string) =>
    download({
        responseType: "blob",
        url: `/booking-orders/${id}/invoice-template`,
        method: "get"
    });

/**
 * 报关单据详情
 */
export const getLoadingPlanListDetail = (loadingPlanListId: string) =>
  request({
    url: `/loading-plan-lists/${loadingPlanListId}`,
    method: "GET"
  });

export const confirmReceipt = (id: string, date: string) =>
  request({
    url: `/booking-orders/${id}/receipt-date`,
    method: "PUT",
    data: { receiptDate: date }
  });
export const financeConfirmReceipt = (id: string, date: string) =>
  request({
    url: `/booking-orders/${id}/finance-receipt-state`,
    method: "PUT",
    data: { receiptDate: date }
  });
export const declare = (id: string) =>
  request({
    url: `/booking-orders/${id}/declaration-state`,
    method: "PUT"
  });

export const updateForwardingCharge = (id: string, confirmed: boolean, data: any) =>
  request({
    url: `/booking-orders/${id}/forwarding-companies/forwarding-charge?confirmed=${confirmed}`,
    method: "PUT",
    data
  });

export const getForwardingCharge = (id: string) =>
  request({
    url: `/booking-orders/${id}/forwarding-companies/forwarding-charge`,
    method: "GET"
  });

export const listSpecialChargeTypes = () =>
  request({
    url: `/booking-orders/special-charge-types`,
    method: "GET"
  });
// 下载舱单信息
export const shippingOrder = (id: string) =>
  request({
    url: `/booking-orders/${id}/shipping-order`,
    method: "GET"
  });
// 下载舱单信息
export const newShippingOrder = (id: string, loadingPlanListId: string) =>
  request({
    url: `/booking-orders/${id}/shipping-order/loading-info/${loadingPlanListId} `,
    method: "GET"
  });
// 获取报关合同验审数据
export const getAuditTable = (id: string) =>
  request({
    url: `/booking-orders/${id}/auditable`,
    method: "GET"
  });
// 验审详情
export const auditDetail = (id: string) =>
    request({
        url:`/booking-orders/${id}/audit/detail`,
        method: "GET"
    })
// 报关合同验审保存和确认
export const saveAuditTable = (id: string, data: any) =>
  request({
    url: `/booking-orders/${id}/auditable`,
    method: "PUT",
    data
  });
// 报关合同验审生成付款单
export const auditCreatePaymentOrder = (id: string) =>
  request({
    url: `/booking-orders/${id}/generate-payment`,
    method: "PUT"
  });
// 查询报关合同下某个工厂下装箱单的费用及备注
export const getMoneyList = (id: string, factoryName: string) =>
  request({
    url: `booking-orders/${id}/hq-packing-lists/money-list?factoryName=${factoryName}`,
    method: "GET"
  });

export const editMoneyList = (id: string, data: any) =>
  request({
    url: `/booking-orders/${id}/hq-packing-lists/money-list`,
    method: "PUT",
    data
  });
// 查看退税资料
export const getTaxRefundInfo = (id: string) =>
  request({
    url: `/booking-orders/${id}/tax-refund-information`,
    method: "GET"
  });
// 修改汇率
export const exchangeRate = (id: string, data: any) =>
  request({
    url: `/booking-orders/${id}/exchange-rate`,
    method: "PUT",
    data
  });
// 是否选择使用发票金额作为报关金额
export const useInvoiceMoney = (id: string, confirm: boolean) =>
  request({
    url: `/booking-orders/${id}/invoice-money?useInvoiceMoney=${confirm}`,
    method: "POST"
  });
// 下载客户IV
export const getExcelUrl = (id: string, accountType: string) =>
  download({
    responseType: "blob",
    url: `/booking-orders/${id}/invoice-template?accountType=${accountType}`,
    method: "GET",
  });
// 查询销售合同或者发票
export const getSalesContractOrInvoice = (id: string) =>
  request({
    url: `/booking-orders/${id}/sales-contract-or-invoice`,
    method: "GET"
  });
// 下载箱单
export const getPackingListInfo = (id: string) =>
  request({
    url: `/booking-orders/${id}/packing-list-infos`,
    method: "GET"
  });
// 查看报关详情-物流员
export const getCustomsDetails = (id: string) =>
  request({
    url: `/booking-orders/${id}/shipping-order/products`,
    method: "GET"
  });
// 修改客户信息-最终目的国
export const customersDestinationCountry = (id: string, data: any) =>
  request({
    url: `/customers/${id}/destinationCountry`,
    method: "PUT",
    data
  });
// 申报要素
export const getDeclarationElements = (id: string) =>
  request({
    url: `/booking-orders/${id}/declaration-elements`,
    method: "GET"
  });
// 客户PL
export const getCustomerPackingList = (id: string) =>
  request({
    url: `/booking-orders/${id}/customer/packing-list`,
    method: "GET"
  });
//删除报关合同
export const deleteBookingOrder = (id: string) =>
  request({
    url: `/booking-orders/${id}`,
    method: "DELETE"
  });
//查看报关单据详情
export const getLoadingPlanProduct = (id: string) =>
  request({
    url: `/booking-order/loading-plan/${id}`,
    method: "GET"
  });
// 查询货代公司
export const getForwardingCompanies = (id: string) =>
  request({
    url: `/booking-orders/${id}/forwarding-companies`,
    method: "GET"
  });
// 新增更新货代公司
export const updateForwardingCompanies = (id: string, data: any) =>
  request({
    url: `/booking-orders/${id}/forwarding-company`,
    method: "PUT",
    data
  });
// 新增货代费用
export const createForwardingCompaniesInvoice = (id: string, data: any) =>
  request({
    url: `/booking-orders/${id}/forwarding-company-invoice`,
    method: "POST",
    data
  });
// 查询货代费用
export const queryForwardingCompaniesInvoiceById = (id: string) =>
  request({
    url: `/booking-orders/${id}/forwarding-company-invoice`,
    method: "GET"
  });
// 删除货代公司
export const deleteForwardingCompanies = (id: string) =>
  request({
    url: `/booking-orders/forwarding-companies/${id}`,
    method: "DELETE"
  });
// 删除货代发票
export const deleteForwardingCompanyInvoice = (id: string, invoiceId: string) =>
  request({
    url: `/booking-orders/${id}/forwarding-company-invoice?invoiceId=${invoiceId}`,
    method: "DELETE"
  });
export const getCustomerOtherInfo = (id: string, keyword: string, group: string) =>
  request({
    url: `/customers/${id}/other-info?group=${group}&keyword=${keyword}`,
    method: "GET"
  });
export const createCustomerOtherInfo = (id: string, data: any) =>
  request({
    url: `/customers/${id}/other-info`,
    method: "POST",
    data
  });
export const createInvoice = (data: any) =>
  request({
    url: `/booking-orders/create-invoice`,
    method: "POST",
    data
  });
export const getExtraCostSettlement = (id: string, params: any) =>
  request({
    url: `/booking-orders/${id}/extra-cost-settlement`,
    method: "GET",
    params
  });

export const createExtraCostSettlement = (id: string, factoryName: any, data: any) =>
  request({
    url: `/booking-orders/${id}/extra-cost-settlement?factoryName=${factoryName}`,
    method: "POST",
    data
  });
  // /booking-orders/{id}/documents
export const uploadDocuments = (id: any, data: any) =>
  request({
    url: `/booking-orders/${id}/documents`,
    method: "POST",
    data
  });
  // /booking-orders/{id}/documents
export const getDocumentsList = (id: any) =>
  request({
    url: `/booking-orders/${id}/documents`,
    method: "get",
  });
  // /booking-orders/documents/{id}
  // 修改备注
export const updateRemark = (id,params: any) =>
  request({
    url: `/booking-orders/documents/${id}`,
    method: "put",
    params
  });
  // /booking-orders/documents
export const deleteQingGuanList = (params: any) =>
  request({
    url: `/booking-orders/documents?${params}`,
    method: "delete",
  }); 
  // /booking-orders/invoice
export const getInvoiceList = (params: any) =>
  request({
    url: `/booking-orders/invoice`,
    method: "get",
    params
  });

  // /booking-orders/{id}/factory/{name}/payment-voucher
  export const updatePaymentOrder = (id,name) =>
    request({
      url: `/booking-orders/${id}/factory/${name}/payment-voucher`,
      method: "put"
    });

  export const getProductInfo = (id: string) =>
      request({
          url: `/booking-orders/${id}/product`,
          method: "get"
      });
  export const downloadShippingOrder = (id: string) =>
      download({
          responseType: "blob",
          url: `/booking-orders/${id}/shipping-order/download`,
          method: "GET",
      });
  export const poFeeSettlement = (params) =>
      omsRequest({
          url: `/purchase-order-other-fee/booking-order-audit`,
          method: "get",
          params
      });

  export const queryBookingOrderAuditUse = (params) =>
      omsRequest({
          url: `/purchase-order-other-fee/booking-order-audit/use`,
          method: "get",
          params
      });

  export const saveBookingOrderAuditUse = (data) =>
      omsRequest({
          url: `/purchase-order-other-fee/booking-order-audit/use`,
          method: "post",
          data
      });

  export const queryPurchaseOrderDistribute = (params) =>
      omsRequest({
          url: `/purchase-order-other-fee/purchase-order/distribute`,
          method: "get",
          params
      });

  export const queryHqPackingListDistribute = (params) =>
      omsRequest({
          url: `/purchase-order-other-fee/hq-packing-list/distribute`,
          method: "get",
          params
      });

  export const queryForwardCompanyInvoiceAudit = (params) =>
      request({
          url: `/booking-order/forward-company-invoice/audit`,
          method: "get",
          params
      });

  export const forwardCompanyInvoicePass = (id, params) =>
      request({
          url: `/booking-order/forward-company-invoice/${id}/audit`,
          method: "put",
          params
      })

// 完成退税
export const taxRefund = (id, params) =>
    request({
        url: `/booking-orders/${id}/tax-refund`,
        method: "PUT",
        params
    });

// 不退税
export const noTaxRefund = (id) =>
    request({
        url: `/booking-orders/${id}/no-tax-refund`,
        method: "PUT",
    });

// 取消退税
export const revertTaxRefund = (id) =>
    request({
        url: `/booking-orders/${id}/revert-tax-refund`,
        method: "PUT",
    });

// 报关单预览
export const previewCustomsDeclaration = (data) =>
  request({
    url: `/preview/customs-declaration`,
    method: "POST",
    data,
  });

export const previewCustomsDeclarationForAudit = (id, data) =>
    request({
        url: `/booking-orders/${id}/preview/customs-declaration/audit`,
        method: "POST",
        data
    });